const STOCKHOLM_TZ = "Europe/Stockholm";

export function toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value === "number") return new Date(value);
  if (typeof value === "string") return new Date(value);
  if (typeof value === "object") {
    if (value.$date) return new Date(value.$date);
    if (value.date) return new Date(value.date);
  }
  return null;
}

export function formatSvDate(value, options = {}) {
  const dt = toDate(value);
  if (!dt || Number.isNaN(dt.getTime())) return "";
  return dt.toLocaleDateString("sv-SE", { timeZone: STOCKHOLM_TZ, ...options });
}

export function formatSvTime(value, options = {}) {
  const dt = toDate(value);
  if (!dt || Number.isNaN(dt.getTime())) return "";
  return dt.toLocaleTimeString("sv-SE", { timeZone: STOCKHOLM_TZ, ...options });
}

export function formatSvDateTime(value, options = {}) {
  const dt = toDate(value);
  if (!dt || Number.isNaN(dt.getTime())) return "";
  return dt.toLocaleString("sv-SE", { timeZone: STOCKHOLM_TZ, ...options });
}

function dateParts(value) {
  const dt = toDate(value);
  if (!dt || Number.isNaN(dt.getTime())) return null;
  const fmt = new Intl.DateTimeFormat("sv-SE", {
    timeZone: STOCKHOLM_TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const parts = fmt.formatToParts(dt);
  const get = (type) => parts.find((p) => p.type === type)?.value || "";
  return `${get("year")}-${get("month")}-${get("day")}`;
}

export function isSameSvDay(a, b) {
  const aKey = dateParts(a);
  const bKey = dateParts(b);
  if (!aKey || !bKey) return false;
  return aKey === bKey;
}

export function getSvYear(value) {
  const dt = toDate(value);
  if (!dt || Number.isNaN(dt.getTime())) return null;
  const parts = new Intl.DateTimeFormat("sv-SE", {
    timeZone: STOCKHOLM_TZ,
    year: "numeric",
  }).formatToParts(dt);
  const year = parts.find((p) => p.type === "year")?.value;
  return year ? Number(year) : null;
}

export { STOCKHOLM_TZ };
